import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

registerPlugin(FilePondPluginImagePreview, FilePondPluginFileValidateType);

export default function ImageUploadSection({
  desktopImageUrl,
  mobileImageUrl,
  desktopImg,
  mobileImg,
  onChangeDesktopUrl,
  onChangeMobileUrl,
  onUpdateDesktopFiles,
  onUpdateMobileFiles,
  handleFilePondLoad,
  showMobile = true,
}) {
  const serverConfig = handleFilePondLoad
    ? { load: handleFilePondLoad }
    : undefined;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
      {/* Desktop Image */}
      <Box>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Desktop Image
        </Typography>
        <TextField
          label="Desktop Image URL (optional)"
          name="desktopImageUrl"
          value={desktopImageUrl || ""}
          onChange={onChangeDesktopUrl}
          fullWidth
          size="small"
          sx={{ mb: 1 }}
        />
        <FilePond
          files={desktopImg}
          onupdatefiles={onUpdateDesktopFiles}
          allowMultiple={false}
          acceptedFileTypes={["image/*"]}
          labelIdle='Drag &amp; Drop your desktop image or <span class="filepond--label-action">Browse</span>'
          server={serverConfig}
          credits={false}
          setOptions
        />
      </Box>

      {/* Mobile Image */}
      {showMobile && (
        <Box>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Mobile Image
          </Typography>
          <TextField
            label="Mobile Image URL (optional)"
            name="mobileImageUrl"
            value={mobileImageUrl || ""}
            onChange={onChangeMobileUrl}
            fullWidth
            size="small"
            sx={{ mb: 1 }}
          />
          <FilePond
            files={mobileImg}
            onupdatefiles={onUpdateMobileFiles}
            allowMultiple={false}
            acceptedFileTypes={["image/*"]}
            labelIdle='Drag &amp; Drop your mobile image or <span class="filepond--label-action">Browse</span>'
            server={serverConfig}
            credits={false}
          />
        </Box>
      )}
    </Box>
  );
}

ImageUploadSection.propTypes = {
  desktopImageUrl: PropTypes.string,
  mobileImageUrl: PropTypes.string,
  desktopImg: PropTypes.array.isRequired,
  mobileImg: PropTypes.array,
  onChangeDesktopUrl: PropTypes.func.isRequired,
  onChangeMobileUrl: PropTypes.func,
  onUpdateDesktopFiles: PropTypes.func.isRequired,
  onUpdateMobileFiles: PropTypes.func,
  handleFilePondLoad: PropTypes.func,
  showMobile: PropTypes.bool,
};
